import script from "./TheMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./TheMenu.vue?vue&type=script&setup=true&lang=js"

import "./TheMenu.vue?vue&type=style&index=0&id=5f30e40a&lang=css"

const __exports__ = script;

export default __exports__